import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import hi from './locales/hi.json';

/**
 * English and Hindi. The Hindi locale is not decoration — it is what makes the
 * app usable by clerical staff in the schools this is sold to, and it is the
 * reason the type system is built on IBM Plex (which ships a Devanagari
 * companion with matching metrics, so a row does not change height when the
 * locale flips).
 *
 * Devanagari runs taller than Latin at the same point size. Anything that
 * hard-codes a height around a label will clip in Hindi — use the row-height
 * tokens and let content set its own line box.
 */
void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hi: { translation: hi },
  },
  lng: localStorage.getItem('language') ?? 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export function setLanguage(lng: 'en' | 'hi') {
  localStorage.setItem('language', lng);
  void i18n.changeLanguage(lng);
}

export default i18n;
